import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "../ng-components/theme";

// Override ANNOYING global styles
export function OverrideGlobalStyles({ children }) {
    const { altTextColor, bodyTextColor, modularScale } = useTheme();
    return (
        <div className="override-global-styles">
            {children}
            <style jsx>{`
                .override-global-styles {
                    text-align: initial;
                    font-size: 16px;
                    line-height: 1.5;
                    color: ${bodyTextColor};
                }
                .override-global-styles :global(p) {
                    font-size: 1em;
                    line-height: 1.35;
                    color: ${bodyTextColor};
                }
                .override-global-styles :global(h3) {
                    display: block;
                    margin-left: 0;
                    color: ${altTextColor};
                    font-size: ${modularScale(2)}em;
                    line-height: 1.25;
                }
            `}</style>
        </div>
    );
}

OverrideGlobalStyles.propTypes = {
    children: PropTypes.node.isRequired,
};
